import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

 var swiper = new Swiper(".section2 .swiper", {
    spaceBetween: 10,
    pagination: {
        el: ".section2 .swiper-pagination",
        clickable: true,
    },
    loop:true,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
	},
    speed:700,
});


